import { loadAllAgent } from "@/redux/rtk/features/CRM/agent/agentSlice";
import { loadAllContact } from "@/redux/rtk/features/CRM/contact/contactSlice";
import { useGetDealStagesQuery } from "@/redux/rtk/features/CRM/dealStage/dealStageApi";
import { loadAllUniversity } from "@/redux/rtk/features/CRM/university/universitySlice";
import { loadAllStaff } from "@/redux/rtk/features/hrm/user/userSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "react-i18next";

export default function useDealFilter(enabled = false) {
    const { t } = useTranslation();
    const { list: agent, loading: agentLoading } = useSelector((state) => state.agent);
    const { list: university, loading: universityLoading } = useSelector((state) => state.university);
    const { data: dealStage, isLoading: stageLoading } = useGetDealStagesQuery(undefined, { skip: !enabled });
    const { list: contact, loading: contactLoading } = useSelector((state) => state.contact);
    const { list: owner, loading: ownerLoading } = useSelector((state) => state.users);
    const dispatch = useDispatch();

    const filter = [
        {
            key: "agentId",
            label: t("deal.agent"),
            loading: agentLoading,
            type: "select",
            options: agent?.map((item) => ({
                label: item.companyName,
                value: item.id,
            })),
            className: "min-w-[85px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "universityId",
            label: t("university.title"),
            loading: universityLoading,
            type: "select",
            options: university?.map((item) => ({
                label: item.universityName || item.name,
                value: item.id,
            })),
            className: "min-w-[85px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "dealStageId",
            label: t("deal.stage"),
            loading: stageLoading,
            type: "select",
            options: dealStage?.map((item) => ({
                label: item.stageName,
                value: item.id,
            })),
            className: "min-w-[85px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "dealOwnerId",
            label: t("deal.dealOwner"),
            loading: ownerLoading,
            type: "select",
            options: (() => {
                const currentList = owner ? [...owner] : [];
                const currentUserId = localStorage.getItem("id");
                const currentUserName = localStorage.getItem("user");

                if (currentUserId && !currentList.some(item => String(item.id) === String(currentUserId))) {
                    currentList.push({
                        id: parseInt(currentUserId),
                        username: currentUserName,
                        firstName: "",
                        lastName: ""
                    });
                }

                return currentList.map((item) => ({
                    label: item?.username || (item.firstName || item.lastName ? `${item.firstName} ${item.lastName}` : null) || `User ${item.id}`,
                    value: item.id,
                }));
            })(),
            className: "min-w-[85px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "contactId",
            label: t("deal.contact"),
            loading: contactLoading,
            type: "select",
            options: contact?.map((item) => ({
                label: `${item.firstName} ${item.lastName}`,
                value: item.id,
            })),
            className: "min-w-[85px] max-w-[150px]",
            popupClassName: "w-[150px]",
        },
        {
            key: "status",
            label: t("common.status"),
            type: "select",
            options: [
                { label: t("common.show"), value: "true" },
                { label: t("common.hide"), value: "false" },
            ],
            className: "min-w-[85px] max-w-[150px]",
            popupClassName: "w-[100px]",
        },
        {
            key: "priority",
            label: t("deal.priority"),
            type: "select",
            options: [
                { label: t("deal.direct"), value: "Direct" },
                { label: t("deal.transfer"), value: "Transfer" },
            ],
            className: "min-w-[85px] max-w-[150px]",
            popupClassName: "w-[100px]",
        },
        {
            key: "phone",
            label: t("common.phone"),
            type: "text",
        },
        {
            key: "mobile",
            label: t("lead.mobile"),
            type: "text",
        },
    ];

    useEffect(() => {
        if (enabled) {
            dispatch(loadAllAgent());
            dispatch(loadAllUniversity());
            dispatch(loadAllContact());
            dispatch(loadAllStaff({ query: "all" }));
        }
    }, [dispatch, enabled]);

    return filter || [];
}
